export const engagementPhotos = [
  { filename: 'DSCF1208.jpg' },
  { filename: 'DSCF1218.jpg' },
  { filename: 'IMG_1638.jpg' },
  { filename: 'DSCF1239.jpg' },
  { filename: 'DSCF1315.jpg' },
  { filename: 'DSCF1351.jpg' },
  { filename: 'IMG_1639.jpg' },
  { filename: 'DSCF1382.jpg' },
  { filename: 'DSCF1410.jpg' },
  { filename: 'DSCF1417.jpg' },
  { filename: 'IMG_1640.jpg' },
  { filename: 'DSCF1428.jpg' },
  { filename: 'DSCF1453.jpg' },
  { filename: 'DSCF1457.jpg' },
  { filename: 'IMG_1641.jpg' },
  { filename: 'DSCF1458.jpg' },
  { filename: 'DSCF1475.jpg' },
  { filename: 'DSCF1485.jpg' },
  { filename: 'IMG_1642.jpg' },
  { filename: 'DSCF1507.jpg' },
  { filename: 'DSCF1523.jpg' },
  { filename: 'IMG_1643.jpg' },
  { filename: 'DSCF1534.jpg' },
];
